import { values } from './enums'

const _enum = {
  Existing: 0,
  NonExisting: 1
}

export const realEstateStatus = {
  enumName: 'RealEstateStatus',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/RealEstateStatus.js